var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// Adjust the import path to where your hook file is located
import { DatabaseContext, useDatabaseManager } from "../hooks/useSQLiteDatabase";
export var DatabaseProvider = function (_a) {
    var children = _a.children;
    // useDatabaseManager creates the state (the map of databases) and the functions to modify it.
    var manager = useDatabaseManager();
    // The Provider component makes this state and these functions available to any child component.
    return (_jsx(DatabaseContext.Provider, __assign({ value: manager.contextValue }, { children: children })));
};
